import Axios from "axios/index";
import { getToken, setToken } from "./tokenManager";
import { deleteCookie } from "./cookie";
import store from "../configureStore";
import {InitAction} from "../actions";
import {REQUEST_TIMEOUT, RESPONSE_500} from "../constants/serverInterrupt";

const Request = config => {
  const needToken = config.needToken;
  const redirectLogin = () => {
    if (typeof window !== "undefined") {
      let href = window.location.href;
      href = href.replace("/login" + window.location.search, "");
      if (window.location.origin !== href) {
        window.location.replace("/?redirect=" + window.location.pathname);
      }
    }
  };
  const removeTokens = () => {
    deleteCookie("accessToken");
    deleteCookie("refreshToken");
    redirectLogin();
  };
  let refreshing = false;
  let queue = [];
  Axios.interceptors.request.use(
    async function(config) {
      if (needToken) {
        Object.assign(config.headers, {
          Authorization: "Bearer " + getToken("accessToken")
        });
      }
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  const processQueue = (error, token = null) => {
    queue.forEach(prom => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
    queue = [];
  };

  Axios.interceptors.response.use(
    function(response) {
      // sessionStorage.removeItem("error-500");
      return response;
    },
    function (error) {
      const originalRequest = error.config;
      if (!error.response) {
        store.dispatch(InitAction.changeServerInterruptStatus(REQUEST_TIMEOUT));
      }
      else if (
        error.response.status >= 500 &&
        !(
          error.response &&
          error.response.data &&
          error.response.data.message &&
          Array.isArray(error.response.data.message) &&
          error.response.data.message.length > 0
        )
      ) {
        store.dispatch(InitAction.changeServerInterruptStatus(RESPONSE_500));
      }
      else if (
        error.response.status === 401 &&
        originalRequest.url === process.env.REACT_APP_API_URL + "/oauth/token"
      ) {
        removeTokens();
      }
      else if (error.response.status === 404) {
        if (error.response.data.project_not_found) {
          if (
            localStorage.getItem("project_id") &&
            localStorage.getItem("project_info")
          ) {
            localStorage.removeItem("project_id");
            localStorage.removeItem("project_info");
            window.location.reload();
          }
        }
      }
      else if (error.response.status === 401 && !originalRequest._refreshTry) {
        if (refreshing) {
          return new Promise(function(resolve, reject) {
            queue.push({ resolve, reject });
          })
            .then(token => {
              originalRequest.headers["Authorization"] = "Bearer " + token;
              return Axios(originalRequest);
            })
            .catch(err => {
              return Promise.reject(err);
            });
        }
        originalRequest._refreshTry = true;
        if (!getToken("refreshToken")) {
          removeTokens();
          return Promise.reject(error);
        }
        refreshing = true;
        return new Promise(function(resolve, reject) {
          Axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/oauth/token",
            data: {
              grant_type: "refresh_token",
              refresh_token: getToken("refreshToken"),
              client_id: process.env.REACT_APP_CLIENT_ID,
              client_secret: process.env.REACT_APP_CLIENT_SECRET
            }
          })
            .then(async response => {
              await setToken(response.data);
              Axios.defaults.headers.common["Authorization"] =
                "Bearer " + getToken("accessToken");
              originalRequest.headers["Authorization"] =
                "Bearer " + getToken("accessToken");
              processQueue(null, getToken("accessToken"));
              resolve(Axios(originalRequest));
            })
            .catch(err => {
              processQueue(err, null);
              reject(err);
            })
            .then(() => {
              refreshing = false;
            });
        });
      }
      return Promise.reject(error);
    }
  );
  return Axios.request(config);
};
export default Request;
